import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import './add.scss'
import Info from './component/Info'
import Coordinate from './component/Coordinate'
import Position from './component/Position'
import Service from './component/Service'
import Location from './component/Location'
import Confirm from './component/Confirm'
import { serviceInfo } from './component/text'

const Add = () => {
  let parameters = useSelector(state => state.global.parameters)
  let user = useSelector(state => state.user)
  const [queryParameters] = useSearchParams()
  const [step, setStep] = useState(1);
  const [submitData, setSubmitData] = useState(null)
  const [userInfo, setUserInfo] = useState(null)
  const service = queryParameters.get("service") || ""
  const County = parameters?.County.data || []
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [step])
  return (
    <div className='relative'>
      {
        step === 1 &&
        <Info
          service={service}
          info={user.info}
          data={userInfo}
          parameters={parameters}
          onSubmit={(obj) => {
            setUserInfo(obj)
            setStep(step + 1)
          }}
        />
      }
      {
        step === 2 && (<Coordinate
            data={submitData}
            onBack={() => setStep(step - 1)}
            parameters={parameters}
            onChange={data => {
              setSubmitData({
                // ...submitData, 
                position: data,
                address: data.address, city: data.city, town: data.town
              })
              setStep(3)
            }} />)
      }
      {
        step === 3 && <Position
          County={County}
          onBack={() => setStep(step - 1)}
          parameters={parameters}
          data={submitData}
          onSubmit={(data) => {
            //刪除拖吊目的地
            delete data.destination
            setSubmitData(data)
            let next = service === "2" || service === "4" ? 6 : 4
            setStep(next)
          }}
        />
      }
      {
        step === 4 && (<Service
          onBack={() => setStep(step - 1)}
          serviceType={service}
          parameters={parameters}
          data={submitData}
          userInfo={userInfo}
          onSubmit={(obj) => {
            setSubmitData({ ...submitData, service: obj })
            //拖吊 或 吊離受困點後需要將車輛拖吊去別處
            let next = service === "1" || obj.is_towed_to?.value ? 5 : 6
            setStep(next)
            // setStep(step+1)
          }}
        />)
      }
      {
        step === 5 && (
          <Location
            County={County}
            serviceType={service}
            parameters={parameters}
            data={submitData}
            userInfo={userInfo}
            identity={user.info}
            onBack={() => setStep(step - 1)}
            onConfirm={(data) => {
              setSubmitData({ ...submitData, destination: data })
              setStep(step + 1)
            }}
          />)
      }
      {
        step === 6 && (
          <Confirm
            onBack={() => {
              let prev =
                service === "4" ? 3 :
                  service === "1" || submitData.service?.is_towed_to?.value ? 5 : 4
              setStep(prev)
            }}
            service={{ id: service, name: serviceInfo[service].name }}
            parameters={parameters}
            data={submitData}
            userInfo={userInfo}
            storeUser={user}
          />)
      }
    </div>
  )
}

export default Add